import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Skeleton } from '@mui/material'
import { Select } from 'packages/eid-ui'
import { usePredefinedComment } from 'hooks'
import { DEFAULT_PREDEFINED_COMMENT_OPTION } from 'utils'

const PredefinedComments = ({
    selectedJustification,
    setSelectedJustification,
    setDecisionComment,
    initialValue,
}) => {
    const { t } = useTranslation()
    const [options, setOptions] = useState([])
    const { isLoading: loadingPredefined, data: predefinedComments } =
        usePredefinedComment()

    useEffect(() => {
        if (predefinedComments?.length) {
            let allOptions = [
                ...predefinedComments,
                DEFAULT_PREDEFINED_COMMENT_OPTION,
            ]
            allOptions = allOptions.map((item) => {
                return {
                    ...item,
                    localKeyName: item?.localKeyName?.replace('MyTasks_', ''),
                }
            })
            setOptions(allOptions)
        } else {
            setOptions([DEFAULT_PREDEFINED_COMMENT_OPTION])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [predefinedComments])

    const getOptionLabel = (option) => t(option?.localKeyName)

    return (
        <Box
            style={{
                padding: '0 24px',
            }}
        >
            {!loadingPredefined ? (
                <Select
                    placeholder={t('Common_PleaseSelectJustification')}
                    options={options}
                    isLoading={loadingPredefined}
                    onChange={(selectedItem) => {
                        setSelectedJustification(selectedItem)
                        setDecisionComment(selectedItem?.localKeyName)
                    }}
                    value={selectedJustification || initialValue}
                    getOptionLabel={getOptionLabel}
                />
            ) : (
                <Skeleton height={20} width="100%" />
            )}
        </Box>
    )
}

export default PredefinedComments
